module.exports = __webpack_public_path__ + "static/animan_3-f266a8c95cc725adc97eed76096182b9.png";